import { createFileRoute, Link } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useListMyMarketplaceOffers } from "@/api/marketplace/offers";
import { Button } from "@/components/ui/button";
import { EditOfferForm } from "./-components/EditOfferForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId/edit",
)({
	component: EditOfferPage,
});

function EditOfferPage() {
	const { orgId, offerId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();
	const { data: offers, isLoading } = useListMyMarketplaceOffers(orgId);

	const offer = offers?.find((o) => o.id === offerId);

	const goBack = () =>
		navigate({
			to: "/app/org/$orgId/marketplace/my-offers",
			params: { orgId },
		});

	return (
		<div className="mx-auto w-full max-w-3xl px-4 py-6 sm:px-6">
			{/* Hero header */}
			<div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex items-center gap-3">
					<div className="grid size-11 place-items-center rounded-xl bg-primary text-primary-content shadow-sm">
						<Pencil className="size-5" />
					</div>
					<div>
						<h1 className="text-2xl font-bold tracking-tight">
							{t("marketplace.createOffer.editTitle")}
						</h1>
						<p className="text-sm text-base-content/60">
							{offer?.title ?? t("marketplace.createOffer.editSubtitle")}
						</p>
					</div>
				</div>
				<Button asChild variant="outline" className="rounded-full">
					<Link to="/app/org/$orgId/marketplace/my-offers" params={{ orgId }}>
						{t("marketplace.myOffers.back")}
					</Link>
				</Button>
			</div>

			{isLoading && (
				<div className="space-y-4">
					{["a", "b", "c"].map((k) => (
						<div
							key={k}
							className="h-28 animate-pulse rounded-xl border border-base-300 bg-base-200/50"
						/>
					))}
				</div>
			)}

			{!isLoading && !offer && (
				<div className="rounded-xl border border-dashed border-base-300 py-16 text-center text-base-content/60">
					{t("marketplace.createOffer.notFound")}
				</div>
			)}

			{!isLoading && offer && (
				<EditOfferForm
					orgId={orgId}
					offer={offer}
					onDone={goBack}
					onCancel={goBack}
				/>
			)}
		</div>
	);
}
